"use client";

import RadioButton from "@/components/atoms/radio-buttons";
import RadioShipping from "@/components/atoms/radio-shipping";
import { FormLabel } from "@/components/ui/form";
import type { ShippingChoice } from "@/lib/checkout-delivery";
import type { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";

type FulfillmentChoiceProps = {
  locale: Locales;
  value: Exclude<ShippingChoice, undefined>;
  onValueChange: (value: Exclude<ShippingChoice, undefined>) => void;
};

const FulfillmentChoice = ({ locale, value, onValueChange }: FulfillmentChoiceProps) => {
  const handleValueChange = (nextValue: string) => {
    if (nextValue === "yes" || nextValue === "no") {
      onValueChange(nextValue);
    }
  };

  return (
    <div className="flex flex-col gap-6.5 sm:gap-3.5">
      <FormLabel className="text-base font-medium">
        {__("I would like Festi to deliver and collect the items?", locale)}{" "}
        <span className="text-pink-primary">*</span>
      </FormLabel>
      <RadioShipping
        locale={locale}
        align="center"
        name="delivery-date-desktop"
        onValueChange={handleValueChange}
        defaultValue={value}
        className="max-w-none flex-row gap-4 max-sm:hidden"
        items={[
          { value: "yes", content: { title: __("Yes", locale) } },
          { value: "no", content: { title: __("No", locale) } },
        ]}
      />
      <RadioButton
        onValueChange={handleValueChange}
        defaultValue={value}
        name="delivery-date-mobile"
        className="w-full justify-evenly sm:hidden"
        options={[
          { value: "yes", label: __("Yes", locale) },
          { value: "no", label: __("No", locale) },
        ]}
      />
    </div>
  );
};

export default FulfillmentChoice;
